export const textNoValue = "Keine Angabe";
export const textNotLinked = "Nicht verknüpft";
export const textNeuerDatensatz = "Neuer Datensatz";
